import { Icon } from '@openeducation/oe-rn-components';
import React, { useEffect, useState } from 'react';
import { TextStyle, TouchableOpacity, View, ViewStyle } from 'react-native';

import styles from './translatable-text.style';
import { useColors, useFont } from '../../hooks/lesson-player.context';
import { ThemedText, ThemedTextProps } from '../themed-text';

interface TranslatableTextProps extends ThemedTextProps {
  translation?: string;
  translateButtonColor?: string;
  translateButtonActiveColor?: string;
  containerStyle?: ViewStyle;
  isMarkdown?: boolean;
  isHtml?: boolean;
  textStyle?: TextStyle;
}

export function TranslatableText({
  children,
  translation,
  translateButtonColor,
  translateButtonActiveColor,
  containerStyle,
  isMarkdown = true,
  isHtml = false,
  fontSize = 'small',
  textStyle,
}: TranslatableTextProps) {
  const [translationActive, setTranslationActive] = useState(false);
  const colors = useColors();
  const fonts = useFont();

  translateButtonColor = translateButtonColor || colors.gray;
  translateButtonActiveColor = translateButtonActiveColor || colors.primary;

  function toggleTranslation() {
    if (translation) {
      setTranslationActive((active) => !active);
    }
  }

  useEffect(() => {
    setTranslationActive(false);
  }, [translation]);

  return (
    <View style={containerStyle}>
      {!!translation && (
        <TouchableOpacity style={styles.button} onPress={toggleTranslation}>
          <Icon
            size={25}
            color={
              translationActive
                ? translateButtonActiveColor
                : translateButtonColor
            }
            name="language"
            type="solid"
          />
        </TouchableOpacity>
      )}
      <ThemedText
        type="gray"
        fontSize={fontSize}
        fontType="secondary"
        style={[
          styles.text,
          textStyle,
          {
            ...fonts.secondary.regular,
          },
        ]}
        isMarkdown={isMarkdown}
        isHtml={isHtml}
      >
        {!translationActive ? children : translation}
      </ThemedText>
    </View>
  );
}
